module.exports = __webpack_public_path__ + "img/gauge-solid.4bc5cbea.svg";